"use client"

import type { ChainIdentifier, FragmentOf } from "@opensea/graphql"
import { useIsHydrated } from "@opensea/ui-kit/hooks"
import type { CurrencyNavigationTab } from "./CurrencyNavigation/types"
import {
  buildCurrencyUrl,
  type currencyUrlFragment,
  getCurrencyUrl as getCurrencyUrlBase,
  getLastCurrencyNavigationTab,
} from "./urls"

export function useCurrencyUrl() {
  const isHydrated = useIsHydrated()

  const getDefaultTabId = (): CurrencyNavigationTab["id"] => {
    if (isHydrated && typeof window !== "undefined") {
      const lastTabId = getLastCurrencyNavigationTab()
      if (lastTabId) {
        return lastTabId
      }
    }
    return "details"
  }

  const getCurrencyUrlByContract = (
    chain: ChainIdentifier,
    contractAddress: string,
    tabId?: CurrencyNavigationTab["id"],
  ) => buildCurrencyUrl(chain, contractAddress, tabId ?? getDefaultTabId())

  const getCurrencyUrl = (
    currencyKey: FragmentOf<typeof currencyUrlFragment>,
    tabId?: CurrencyNavigationTab["id"],
  ) => getCurrencyUrlBase(currencyKey, tabId ?? getDefaultTabId())

  return {
    getCurrencyUrlByContract,
    getCurrencyUrl,
  }
}
